import type { PerioToothData } from '@/modules/insuranceExport/types';

export const ToothNumbers = ({
  teeth,
  isUpper,
}: {
  teeth: PerioToothData[];
  isUpper: boolean;
}) => (
  <div className="vai-flex vai-bg-gray-100 vai-border-t vai-border-b vai-border-gray-400">
    <div className="vai-w-40 vai-border-r vai-border-gray-400 vai-flex vai-items-center vai-justify-center vai-font-semibold">
      {isUpper ? 'F' : 'L'}
    </div>
    {teeth.map((tooth, index) => (
      <div
        key={tooth.toothNumber}
        className={`vai-flex-1 vai-p-2 ${
          index < teeth.length - 1 ? 'vai-border-r vai-border-gray-400' : ''
        }`}
      >
        <div className="vai-flex">
          <div className="vai-flex-1" />
          <div className="vai-flex-1 vai-text-center">
            <div className="vai-w-6 vai-h-6 vai-rounded-full vai-border-2 vai-border-gray-600 vai-flex vai-items-center vai-justify-center vai-mx-auto vai-text-xs vai-font-semibold">
              {tooth.toothNumber}
            </div>
          </div>
          <div className="vai-flex-1" />
        </div>
      </div>
    ))}
  </div>
);
